
import { ScrollTo } from "./ScrollTo";
import { Video } from "./Video";
import AbstractPage from './AbstractPage';
import SwiperManager from '../modules/SwipersManager';
import OverlaysManager from '../modules/OverlaysManager';

export class Services extends AbstractPage {

    private _elAnchor           : NodeListOf<HTMLElement>;
    
    private _elVideoPoster      : HTMLElement;

    private _swipersManager  : SwiperManager;
    private _overlaysManager  : OverlaysManager;

    private _videos             : Array<Video>         = [];

    protected _lastBreakpointSize : {height: number, width: number} = {height: 0, width: 0};

    constructor(){
        super();
        
        this._swipersManager = new SwiperManager(); 
        this._overlaysManager = new OverlaysManager(); 
        this._createAnchorsAnimations();
        this._createVideos();
    }

    private _createAnchorsAnimations(){
        this._elAnchor = document.querySelectorAll('[data-anchor-link]') as NodeListOf<HTMLElement>;
        let _elAnchorLength : number = this._elAnchor.length;
        for(let i = 0; i < _elAnchorLength; i++){
            this._elAnchor[i].addEventListener('click', function(e){
                e.preventDefault();
                let elClick = this._elAnchor[i];
                let anchorName : string = elClick.getAttribute('href');
                let element = document.getElementById(anchorName.replace('#',''));
                new ScrollTo(element);
            }.bind(this));
        }
    }

    private _createVideos(){
        this._elVideoPoster = document.querySelector('[data-js-vimeo]') as HTMLElement;
        if (!this._elVideoPoster) return;
        this._elVideoPoster.addEventListener('click', function(e) {
            let elParent = this._elVideoPoster;
            let idVideo : string = elParent.getAttribute('data-js-vimeo');
            let elPoster = elParent.querySelector('.video_poster') as HTMLElement;
            this._videos.push(new Video(idVideo, elParent, elPoster));
        }.bind(this));
    }

    protected onResize() {
        if ( Math.abs(this._lastBreakpointSize.width-window.innerWidth) > 0 || Math.abs(this._lastBreakpointSize.height - window.innerHeight) >= 100) {
            this._lastBreakpointSize.width = window.innerWidth;
            this._lastBreakpointSize.height = window.innerHeight;
    
            if (this._swipersManager) this._swipersManager.onResize();    
            if (this._overlaysManager) this._overlaysManager.onResize();
        } 
    }

    protected onResizeMobile() {
        super.onResizeMobile();
        if (!this._swipersManager.mobileSwipers.length) this._swipersManager.createSwipersMobile();
    }

    protected onResizeDesktop() { 
        super.onResizeDesktop();
        if (this._swipersManager.mobileSwipers.length) this._swipersManager.destroySwipersMobile();
    } 

}